import { alpha, Box } from '@mui/material';

/**
 * Non-interactive overlay: faint primary-tinted wash plus a light grid (draft / “blueprint” cue).
 */
export function ProjectCardMediaBlueprintGrid() {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        pointerEvents: 'none',
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
        backgroundImage: (theme) => {
          const line = alpha(theme.palette.primary.main, 0.15);
          return `linear-gradient(${line} 1px, transparent 1px), linear-gradient(90deg, ${line} 1px, transparent 1px)`;
        },
        backgroundSize: (theme) => `${theme.spacing(2.75)} ${theme.spacing(2.75)}`,
      }}
    />
  );
}
